<mat-radio-group [formControl]="formControl" (change)="ngOnChanges([])">
  <div class="flex flex-col justify-start">
    <mat-radio-button *ngFor="let option of options" [value]="option">
      <div class="mb-2 pl-2">
        <span class="font-bold">{{ option | role }}</span
        ><br /><span class="text-sm"
          >{{ "roles.inviteHints." + option | translate }}
        </span>
      </div>
    </mat-radio-button>
  </div>
</mat-radio-group>
